import OcuEntityValidationResult from 'app/admin/common/dto/OcuEntityValidationResult';
import nBossConnection from 'modules/base/service/nBossConnection';
import OptimizationCaseTaskEditDto from '../dto/OptimizationCaseTaskEditDto';

class OptimizationCaseTaskEditService {
	constructor() {
		this.connection = nBossConnection.connection;
		this.PARENT_CONTROL = 'taskManagerControl';
		this.CONTROL = 'optimizeTaskEditControl';
	}

	/**
	 * @return {Promise<OptimizationCaseTaskEditDto>}
	 */
	create() {
		return new Promise((resolve, reject) => {
			this.connection
				.get(`/${this.CONTROL}/create`)
				.then(response => resolve(new OptimizationCaseTaskEditDto().setup(response.data)))
				.catch(reject);
		});
	}

	/**
	 * @param {string} type
	 * @return {Promise<OptimizationCaseTaskEditDto>}
	 */
	createByType(type) {
		return new Promise((resolve, reject) => {
			this.connection
				.get(`/${this.CONTROL}/create`)
				.then(response => resolve(new OptimizationCaseTaskEditDto().setup({ ...response.data, type })))
				.catch(reject);
		});
	}

	/**
	 * @param {number} id
	 * @return {Promise<OptimizationCaseTaskEditDto>}
	 */
	getData(id) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getData`, {
					id
				})
				.then(response => resolve(new OptimizationCaseTaskEditDto().setup(response.data)))
				.catch(reject);
		});
	}

	/**
	 * @param {OptimizationCaseTaskEditDto} dto
	 * @return {Promise<OcuEntityValidationResult>}
	 */
	save(dto) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/save`, { dto })
				.then(response => resolve(new OcuEntityValidationResult().setup(response.data)))
				.catch(reject);
		});
	}

	/**
	 * @param {number} id
	 * @param {OptimizationCaseTaskEditDto} dto
	 * @return {Promise<OcuEntityValidationResult>}
	 */
	update(id, dto) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/update`, {
					id,
					dto
				})
				.then(response => resolve(new OcuEntityValidationResult().setup(response.data)))
				.catch(reject);
		});
	}
}

export default new OptimizationCaseTaskEditService();